import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function SpaceWrapped(props: Props) {
  const { children } = props;

  return <> {children} </>;
}

export default SpaceWrapped;
